const devices = {
  desktop: 1440,
  laptop: 800,
  largeDesktop: 1920,
  largeLaptop: 1200,
  largeTablet: 800,
  largeTabletMax: 1024,
  mediumDesktop: 1600,
  mediumLaptop: 1024,
  mobile: 320,
  tablet: 600,
}

const tabletQuery = `(min-width: ${devices.tablet}px) and (max-width: ${
  devices.largeTablet - 1
}px)`
const largeTabletQuery = `(min-width: ${devices.largeTablet}px) and (max-width: ${devices.largeTabletMax}px) and (orientation: portrait)`
const laptopQuery = `(min-width: ${
  devices.laptop
}px) and (orientation: landscape), (min-width: ${devices.largeTabletMax + 1}px)`

export default {
  desktop: `(min-width: ${devices.desktop}px)`,
  laptop: laptopQuery,
  largeDesktop: `(min-width: ${devices.largeDesktop}px)`,
  largeLaptop: `(min-width: ${devices.largeLaptop}px)`,
  largerThanMobile: `(min-width: ${devices.tablet}px)`,
  mediumDesktop: `(min-width: ${devices.mediumDesktop}px)`,
  mediumLaptop: `(min-width: ${devices.mediumLaptop}px)`,
  mobileAndTabletOnly: `(max-width: ${
    devices.tablet - 1
  }px), ${tabletQuery}, ${largeTabletQuery}`,
  mobileOnly: `(max-width: ${devices.tablet - 1}px)`,
  tablet: `${tabletQuery}, ${largeTabletQuery}`,
}
